import { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sendContactForm, resetContactFormState } from "../../redux/contactSlice";
import FormIcon from "../../Assets/Svg/Form/FormIcon.svg";
import "./Form.css";

export default function FormWebAr() {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.contact);

  const formRef = useRef();
  const [captcha, setCaptcha] = useState("");
  const [userCaptchaInput, setUserCaptchaInput] = useState("");
  const [isCaptchaOpen, setIsCaptchaOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [subjectError, setSubjectError] = useState("");
  const [messageError, setMessageError] = useState("");

  useEffect(() => {
    generateCaptcha();
    dispatch(resetContactFormState());
  }, []);

  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10);
    const num2 = Math.floor(Math.random() * 10);
    setCaptcha(`${num1} + ${num2}`);
  };

  const validateName = (e) => {
    const value = e.target.value.trim();
    if (value.trim().length < 3) {
      setNameError("يجب أن يتكون الاسم من 3 أحرف على الأقل.");
    } else {
      setNameError("");
    }
  };

  const validateEmail = (e) => {
    const value = e.target.value.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value.trim())) {
      setEmailError("يرجى إدخال عنوان بريد إلكتروني صالح .");
    } else {
      setEmailError("");
    }
  };
  const validatePhone = (e) => {
    const value = e.target.value.trim();
    if (value.trim().length < 11) {
      setPhoneError("أدخل رقم هاتف صالحًا .");
    } else {
      setPhoneError("");
    }
  };
  const validateSubject = (e) => {
    const value = e.target.value.trim();
    if (value.trim().length < 3) {
      setSubjectError("يجب أن يتكون الموضوع من 3 أحرف على الأقل.");
    } else {
      setSubjectError("");
    }
  };
  const validateMessage = (e) => {
    const value = e.target.value.trim();
    if (value.trim().length < 3) {
      setMessageError("الرسالة مطلوبة.");
    } else {
      setMessageError("");
    }
  };

  const validateInputs = (formData) => {
    let isValid = true;

    const requiredFields = [
      { field: "user_name", setError: setNameError, error: "الاسم مطلوب." },
      { field: "user_email", setError: setEmailError, error: "البريد الإلكترونى مطلوب.", regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/ },
      { field: "user_phone", setError: setPhoneError, error: "رقم الهاتف مطلوب." },
      { field: "user_subject", setError: setSubjectError, error: "الموضوع مطلوب." },
      { field: "user_message", setError: setMessageError, error: "الرسالة مطلوبة." },
    ];

    for (const { field, setError, error, regex } of requiredFields) {
      const value = formData.get(field)?.trim();
      if (!value || (regex && !regex.test(value))) {
        setError(error);
        isValid = false;
      } else {
        setError("");
      }
    }

    return isValid;
  };

  const sendEmailAfterVerification = (e) => {
    e.preventDefault();
    const form = formRef.current;
    const formData = new FormData(form);
    if (!validateInputs(formData)) return;
    setIsCaptchaOpen(true);
  };

  const verifyCaptchaAndSendEmail = async () => {
    const captchaValues = captcha.split(" + ").map(Number);
    const correctCaptchaAnswer = captchaValues[0] + captchaValues[1];

    if (parseInt(userCaptchaInput) !== correctCaptchaAnswer) {
      alert("Captcha verification failed. Please try again.");
      return;
    }

    try {
      const form = formRef.current;
      const formData = new FormData(form);
      const payload = {
        name: formData.get("user_name"),
        email: formData.get("user_email"),
        phone: formData.get("user_phone"),
        city: formData.get("user_city"),
        message: formData.get("user_message"),
        subject: formData.get("user_subject"),
      };

      await dispatch(sendContactForm(payload)).unwrap();

      setIsSuccess(true);
      setUserCaptchaInput("");
      setCaptcha("");
      form.reset();
      generateCaptcha();
    } catch (err) {
      console.error("Form submission failed:", err);
      if (typeof err === "string") alert(err);
      else if (typeof err === "object" && err.errors) {
        const allErrors = Object.values(err.errors).flat().join("\n");
        alert(allErrors);
      } else {
        alert("Something went wrong. Please try again.");
      }
    }
  };

  const enforceWordLimit = (event, maxWords) => {
    const textarea = event.target;
    const words = textarea.value.trim().split(/\s+/);
    if (words.length > maxWords) {
      textarea.value = words.slice(0, maxWords).join(" ");
      alert(`You can only enter up to ${maxWords} words.`);
    }
  };

  return (
    <>
      <form ref={formRef} onSubmit={sendEmailAfterVerification}>
        <div className="ContactUsBig">
          <div className="FormWebContainer">
            <div className="FormWTC ar">
              <div className="FormWP1">
                {/*  */}
                <div className="FiledBoxContainer">
                  <InputBoxAr label="الاسم" name="user_name" required onBlur={validateName} error={nameError} placeholder="الاسم" />
                </div>
                {/* Email */}
                <div className="FiledBoxContainer">
                  <InputBoxAr label="البريد الإلكتروني" name="user_email" required onBlur={validateEmail} error={emailError} placeholder="example@gmail.com" />
                </div>
                {/* Phone */}
                <div className="FiledBoxContainer">
                  <InputBoxAr label="رقم الهاتف" name="user_phone" required onBlur={validatePhone} error={phoneError} placeholder="+20" />
                </div>
                {/* City */}
                <InputBoxAr label="المدينة" name="user_city" placeholder="مدينتك الحالية للإقامة" />

                {/*  */}
              </div>
              <div className="FormWP1">
                {/* Subject */}
                <div className="FiledBoxContainer">
                  <InputBoxAr
                    label="الموضوع"
                    name="user_subject"
                    required
                    onBlur={validateSubject}
                    error={subjectError}
                    placeholder="غرض رسالتك (على سبيل المثال، الاستفسار عن المنتج، التعليقات، وما إلى ذلك)"
                  />
                </div>
                {/* Message */}
                <div className="FiledBoxContainer">
                  <InputBoxAr
                    label="الرسالة"
                    name="user_message"
                    textarea
                    required
                    onBlur={validateMessage}
                    onInput={(e) => enforceWordLimit(e, 1000)}
                    error={messageError}
                    placeholder="رسالتك لنا، بما في ذلك أي تفاصيل أو أسئلة"
                  />
                </div>
                {/*  */}
              </div>
            </div>

            {/*  */}
            <div className="FormWSubmit ar">
              <button className="FromWsubmitB ar TFut16PxPCUC" type="submit" disabled={loading}>
                {" "}
                <img src={FormIcon} alt="" /> إرسال الاستفسار
              </button>
            </div>
          </div>
          {/*  */}
          {/*  */}
          {/* Captcha Pop-up */}
          {isCaptchaOpen && (
            <CaptchaModal
              captcha={captcha}
              userCaptchaInput={userCaptchaInput}
              setUserCaptchaInput={setUserCaptchaInput}
              onCancel={() => {
                setIsCaptchaOpen(false);
                setUserCaptchaInput("");
                generateCaptcha();
              }}
              onVerify={verifyCaptchaAndSendEmail}
              isLoading={loading}
              isSuccess={isSuccess}
            />
          )}
          {/*  */}
          {/*  */}
        </div>
      </form>
      {/*  */}
    </>
  );
}

function InputBoxAr({ label, name, required, placeholder, onBlur, onInput, error, textarea }) {
  return (
    <div className="FiledBoxContainer">
      <div className="InputFieldBox ar">
        <div className="IFBT ar">
          <div className="IFBTN ar TFut24PxPC">{label}</div>
          {required && <div className="IFBTR ar TFut16PxPCUC">(مطلوب)</div>}
        </div>
        <div className="InputMob">
          <label className="InputLabelMob">
            {textarea ? (
              <textarea className="IFBI ar TFut20PxPC" name={name} placeholder={placeholder} onBlur={onBlur} onInput={onInput} />
            ) : (
              <input className="IFBI ar TFut20PxPC" type="text" name={name} placeholder={placeholder} onBlur={onBlur} />
            )}
          </label>
        </div>
      </div>
      {error && (
        <div className={`error-message_Ar${textarea ? "_Last" : ""} TF16PxSC`} dir="rtl">
          {error}
        </div>
      )}
    </div>
  );
}

function CaptchaModal({ captcha, userCaptchaInput, setUserCaptchaInput, onVerify, onCancel, isLoading, isSuccess }) {
  return (
    <div className="captchaModal">
      <div className="captchaModalContent">
        {isLoading ? (
          <div className="CPLoading ar TFut16PxPCUC">يرجى الإنتظار</div>
        ) : isSuccess ? (
          <div className="CaptchaSubmit">
            <div className="CPMessage ar TFut16PxPCUC" dir="rtl">
              شكرًا لك<span className="SpanBigger">,</span> لقد تم إرسال بريدك الإلكتروني<span className="SpanBigger">,</span>وسيتصل بك أحد أعضاء فريقنا قريبًا
              .
            </div>
            <button onClick={onCancel} className="CaptchaSubB ar TFut16PxPCUC">
              إنهاء
            </button>
          </div>
        ) : (
          <div className="CaptchaQAContainer">
            <div className="CaptchaQ">
              <div className="CaptchaQP1 ar TGLo32PxPC">التحقق البشري</div>
              <div className="CaptchaQP2 ar TFut16PxPCUC" dir="rtl">
                يرجى حل المسألة الرياضية أدناه للمتابعة: ما هو جمع <span></span>
                {captcha} ؟
              </div>
            </div>
            <div className="CaptchaAA">
              <input
                type="text"
                className="CaptchaAnswerF TFut16PxPCUC"
                placeholder="_"
                value={userCaptchaInput}
                onChange={(e) => setUserCaptchaInput(e.target.value)}
              />
              <div className="CaptchaBB">
                <button onClick={onCancel} className="CaptchaC ar TFut16PxPCUC">
                  إلغاء
                </button>
                <button onClick={onVerify} className="CaptchaV ar TFut16PxPCUC">
                  تحقق
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
